// PROMCitations.jsx

function PROMCitations({ promName }) {
  if (!promName) return null;

  const citations = {
    VHI: (
      <div>
        <strong>VHI – Voice Handicap Index:</strong><br />
        Jacobson, B. H., Johnson, A., Grywalski, C., et al. (1997). The Voice Handicap Index (VHI): Development and validation. <em>American Journal of Speech-Language Pathology, 6</em>(3), 66–70. <a href="https://doi.org/10.1044/1058-0360.0603.66" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360.0603.66</a><br /><br />
      </div>
    ),
    AVI: (
      <div>
        <strong>AVI – Aging Voice Index:</strong><br />
        Etter, N. M., Hapner, E. R., Barkmeier-Kraemer, J., & Johns, M. M. (2018). Aging Voice Index (AVI): Reliability and validity of a voice quality of life scale for older adults. <em>Journal of Voice, 33</em>(6), 807.e7–807.e12. <a href="https://doi.org/10.1016/j.jvoice.2018.04.006" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2018.04.006</a><br /><br />
      </div>
    ),
    DSSES: (
      <div>
        <strong>DSSES – Disease Specific Self-Efficacy in Spasmodic Dysphonia:</strong><br />
        Hu, A., Isetti, D., Hillel, A. D., et al. (2013). Disease-specific self-efficacy in spasmodic dysphonia patients. <em>Otolaryngology–Head and Neck Surgery, 148</em>(3), 450–455. <a href="https://doi.org/10.1177/0194599812472319" target="_blank" rel="noopener noreferrer">https://doi.org/10.1177/0194599812472319</a><br /><br />
      </div>
    ),
    EASE: (
      <div>
        <strong>EASE – Evaluation of the Ability to Sing Easily:</strong><br />
        Phyland, D. J., Pallant, J. F., Benninger, M. S., et al. (2013). Development and preliminary validation of the EASE: A tool to measure perceived singing voice function. <em>Journal of Voice, 27</em>(4), 454–465. <a href="https://doi.org/10.1016/j.jvoice.2013.01.019" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2013.01.019</a><br /><br />
      </div>
    ),
    EVDQOL: (
      <div>
        <strong>EVD-QOL – Evaluating Voice Disability - Quality of Life:</strong><br />
        Smith, E., Verdolini, K., Gray, S. D., et al. (1996). Effect of voice disorders on quality of life. <em>Journal of Medical Speech-Language Pathology, 4</em>, 223–244.<br /><br />
      </div>
    ),
    GFI: (
      <div>
        <strong>GFI – Glottal Function Index:</strong><br />
        Bach, K. K., Belafsky, P. C., Wasylik, K., et al. (2005). Validity and reliability of the Glottal Function Index. <em>Archives of Otolaryngology–Head & Neck Surgery, 131</em>(11), 961–964. <a href="https://doi.org/10.1001/archotol.131.11.961" target="_blank" rel="noopener noreferrer">https://doi.org/10.1001/archotol.131.11.961</a><br /><br />
      </div>
    ),
    LASAVQ: (
      <div>
        <strong>LASA-VQ – Linear Analog Scale of Assessment of Voice Quality:</strong><br />
        Llewellyn-Thomas, H., Sutherland, H. J., Hogg, S. A., et al. (1984). Linear analogue self-assessment of voice quality in laryngeal cancer. <em>Journal of Chronic Diseases, 37</em>(12), 917–924.<br /><br />
      </div>
    ),
    QOLRRP: (
      <div>
        <strong>QOL-RRP – Quality of Life in Recurrent Respiratory Papillomatosis:</strong><br />
        Hill, D. S., Akhtar, S., Carroll, A., et al. (2000). Quality of life issues in recurrent respiratory papillomatosis. <em>Clinical Otolaryngology, 25</em>(2), 153–160.<br /><br />
      </div>
    ),
    SDQ: (
      <div>
        <strong>SDQ – Speech Disability Questionnaire:</strong><br />
        Epstein, R., Stygall, J., Newman, S. (1997). The short-term impact of Botox injections on speech disability in adductor spasmodic dysphonia. <em>Disability and Rehabilitation, 19</em>(1), 20–25. <a href="https://doi.org/10.3109/09638289709166441" target="_blank" rel="noopener noreferrer">https://doi.org/10.3109/09638289709166441</a><br /><br />
      </div>
    ),
    TWVQ: (
      <div>
        <strong>TWVQ – Trans Woman Voice Questionnaire:</strong><br />
        Dacakis, G., Davies, S., Oates, J., et al. (2013). Development and preliminary evaluation of the Transsexual Voice Questionnaire for male-to-female transsexuals. <em>Journal of Voice, 27</em>(3), 312–320. <a href="https://doi.org/10.1016/j.jvoice.2012.11.005" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2012.11.005</a><br /><br />
      </div>
    ),
    VCDQ: (
      <div>
        <strong>VCDQ – Vocal Cord Dysfunction Questionnaire:</strong><br />
        Fowler, S. J., Thurston, A., Chesworth, B., et al. (2015). The VCDQ – A questionnaire for symptom monitoring in vocal cord dysfunction. <em>Clinical and Experimental Allergy, 45</em>(9), 1406–1411. <a href="https://doi.org/10.1111/cea.12550" target="_blank" rel="noopener noreferrer">https://doi.org/10.1111/cea.12550</a><br /><br />
      </div>
    ),
    VFI: (
      <div>
        <strong>VFI – Vocal Fatigue Index:</strong><br />
        Nanjundeswaran, C., Jacobson, B. H., Gartner-Schmidt, J., et al. (2015). Vocal Fatigue Index (VFI): Development and validation. <em>Journal of Voice, 29</em>(4), 433–440. <a href="https://doi.org/10.1016/j.jvoice.2014.09.012" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2014.09.012</a><br /><br />
      </div>
    ),
    VTD: (
      <div>
        <strong>VTD – Vocal Tract Discomfort Scale:</strong><br />
        Mathieson, L., Hirani, S. P., Epstein, R., et al. (2009). Laryngeal manual therapy: A preliminary study to examine its treatment effects in the management of muscle tension dysphonia. <em>Journal of Voice, 23</em>(3), 355–366. <a href="https://doi.org/10.1016/j.jvoice.2007.10.002" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2007.10.002</a><br /><br />
      </div>
    )
  };

  return citations[promName] || null;
}

export default PROMCitations;